import { render, staticRenderFns } from "./TargetReviewer.vue?vue&type=template&id=8350f3d6"
import script from "./TargetReviewer.vue?vue&type=script&lang=js"
export * from "./TargetReviewer.vue?vue&type=script&lang=js"
import style0 from "./TargetReviewer.vue?vue&type=style&index=0&id=8350f3d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports